import React, { Component } from 'react';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Section, Grid, Cell } from 'formlabs-web-components/Grid';
import { Header } from 'formlabs-web-components/Type';

import { HeroSection } from '../../../common/components/content';

import JobApplication from './JobApplication';

const Job = DisplayComponent(
  class Job extends Component {
    render() {
      const { title, id, content, departments, location } = this.props;
      return (
        <div>
          <HeroSection
            themeColor="#fff"
            backgroundColor="#000"
            headline={title}
            copyPosition="center"
            copyBackgroundColor="transparent"
            backgroundImage="https://careers-content-staging-media.formlabs.com/filer_public/ad/57/ad57a3b8-3581-4c79-9cc3-ca6b4e2b74f0/finishing_chaoin_print.jpg"
            imageSize={100}
            copyWidth={18}
            heightRestrict={true}
            backgroundHeight={380}
            backgroundWidth={2110}
          />
          <Section hasContainer={true} marginBefore="6rem">
            <Grid
              direction="x"
              primaryAlignment="align-center"
              gutters="margin"
            >
              <Cell smallSize="24" mediumSize="11">
                <div>
                  <Header
                    level={2}
                    displayAs={4}
                    styles={{ marginTop: '30px' }}
                  >
                    {title}
                  </Header>
                  <p>
                    <span>
                      {departments[0] && (
                        <span>
                          <strong>Department:</strong> {departments[0].name}{' '}
                          <br />
                        </span>
                      )}
                      <strong>Location:</strong> {location.name}
                    </span>
                  </p>
                </div>
                <hr />
                <div dangerouslySetInnerHTML={{ __html: content }} />
                <div>
                  <p>
                    To all recruitment agencies: Formlabs does not accept agency
                    resumes. Please do not forward resumes to our jobs alias,
                    Formlabs employees or any other company location. Formlabs
                    is not responsible for any fees related to unsolicited
                    resumes. Unsolicited resumes received will be considered our
                    property and will be processed accordingly.
                  </p>
                </div>
              </Cell>
              <Cell smallSize="24" mediumSize="11">
                <JobApplication id={id} />
              </Cell>
            </Grid>
          </Section>
        </div>
      );
    }
  }
);

export default Job;
